<template>
  <el-dialog :visible="show" append-to-body width="400px" :title="`${row ? '修改' : '新增'}分组`" @close="$emit('update:show', false)">
    <el-form label-width="80px" v-loading="loading" :model="vForm" ref="vForm">
      <el-form-item label="拍摄日期" prop="record_time" :rules="{ required: true, message: '拍摄日期必填' }">
        <el-date-picker v-model="vForm.record_time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: Object.create(null),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      doSubmitLoading: false,
      vForm: {
        id: '',
        works_id: this.$route.query.id,
        name: '',
        record_time: '',
        status: 1,
      },
    };
  },

  created() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
    }
  },

  methods: {
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.group[this.row ? 'edit' : 'add'](this.vForm);
        this.$message.success({
          message: `${this.row ? '修改' : '新增'}成功`,
          offset: 50,
        });
        this.$emit('update:show', false);
        this.$store.dispatch('tour/getGroupList', this.$route.query.id);
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>
